import { useState } from 'react'
import { ResponseEmployeesBooking } from 'services/fetch-employees-by-status'

interface EmployeeBookingProps {
  employees: ResponseEmployeesBooking[]
}

export default function EmployeeBooking({ employees }: EmployeeBookingProps) {
  const [activeButton, setActiveButton] = useState('7days')
  const [employee, setEmployee] = useState(
    employees.length === 0 ? 0 : employees[0].total,
  )

  const buttonClasses = (buttonName: string) => {
    const baseClasses = 'block cursor-pointer py-3 px-4 rounded-3xl text-center'
    const activeClasses =
      'bg-[#4F46E5] text-white shadow-[1px_1px_2px_0px_#00000026]'
    const inactiveClasses = 'text-black dark:text-white'

    return buttonName === activeButton
      ? `${baseClasses} ${activeClasses}`
      : `${baseClasses} ${inactiveClasses}`
  }

  return (
    <section className="bg-[#F9FAFB] w-1/3 dark:bg-[#1F2937] rounded-3xl flex flex-col items-center p-5 gap-10">
      <span className="text-[#000000] dark:text-[#ffffff] text-center font-bold text-3xl">
        Funcionários que reservaram
      </span>
      <div className="flex items-center font-medium text-sm border border-[#D1D5DB] shadow-sm rounded-3xl">
        <span
          className={buttonClasses('7days')}
          onClick={() => {
            setActiveButton('7days')
            setEmployee(employees.length === 0 ? 0 : employees[0].total)
          }}
        >
          últimos 7 dias
        </span>
        <span className="h-5 w-[1px] bg-neutral-300 dark:bg-neutral-700"></span>
        <span
          className={buttonClasses('month')}
          onClick={() => {
            setActiveButton('month')
            setEmployee(employees.length === 0 ? 0 : employees[1].total)
          }}
        >
          último mês
        </span>
        <span className="h-5 w-[1px] bg-neutral-300 dark:bg-neutral-700"></span>
        <span
          className={buttonClasses('year')}
          onClick={() => {
            setActiveButton('year')
            setEmployee(employees.length === 0 ? 0 : employees[2].total)
          }}
        >
          último ano
        </span>
      </div>
      <div className="flex flex-col">
        <span
          className="text-[#000000] dark:text-[#ffffff] font-bold
        text-[140px] flex flex-col items-center pt-[70px]"
        >
          {employee}
        </span>
        <span className="text-[#000000] dark:text-[#ffffff] text-center font-bold text-2xl pt-[80px]">
          de seus colaboradores já fizeram bom uso do seu benefício!!
        </span>
      </div>
    </section>
  )
}
